import { Block, type Inline, Text } from '@gitbook/slate';

import { BLOCK_PARAGRAPH } from '../types';

/**
 * Create a paragraph with some text
 */
export function createParagraph(text: string | Array<Inline | Text> = '') {
    return Block.create({
        type: BLOCK_PARAGRAPH,
        nodes: typeof text === 'string' ? [Text.create(text)] : text,
    });
}
